import React from "react";
import { useStateContext } from "../../../context/ContextProvider";
import useFadeInOnScroll from "../../../components/Effects/FadeInOnScroll";

import img1 from "../../../assets/images/services/2-1.png";
import img2 from "../../../assets/images/services/2-2.png";
import img3 from "../../../assets/images/services/2-3.png";

const CreativeServices = () => {

    const {
        isMobile
    } = useStateContext();

    useFadeInOnScroll();

    const cards = [
        {
            title: "Content Creation: Developing posts, stories, reels, and ads designed to captivate users.",
            image: img1,
        },
        {
            title: "Video Editing: Producing professional-grade videos using top-notch tools like the best video editing apps available.",
            image: img2,
        },
        {
            title: "Posting Schedules: Optimizing timing to ensure maximum visibility based on platform-specific insights          ",
            image: img3,
        }
    ];

    const prolist = [
        {
            text: "Our Creative services",
            active: true
        },
    ];
    return (
        <>
            <div className="w-full relative py-5 my-5 flex flex-col gap-5">
                <div className="h-[50px]"></div>
                {/* 1 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-1">
                    <div className="fade-element text:4xl md:text-5xl lg:text-6xl capitalize font-bold">
                        Creative Services: Crafting Engaging Content for Your Brand
                    </div>
                    <div className="w-full flex justify-end">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            In today’s digital age, creative services play a pivotal role in shaping how businesses connect with their audiences.
                            At DO DEAL, we specialize in providing comprehensive creative solutions that include content creation, video editing, and strategic posting schedules tailored to maximize engagement across social media platforms.
                        </div>
                    </div>
                </div>
                {/* 2 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold">
                        Why Creative Services Matter ?
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            Creative content is the backbone of any successful marketing strategy.
                            Whether it’s visually stunning images, captivating videos, or well-crafted captions, high-quality content helps your brand stand out in an increasingly crowded online space.
                            Our team at DO DEAL focuses on creating engaging materials that resonate with your target audience and drive meaningful interactions.
                        </div>
                    </div>
                </div>
                {/* 3 */}
                <div className="relative padding-container w-full my-5 py-5 text-center z-1">
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {prolist?.map((list, index) => (
                            <div
                                key={index}
                                className={`fade-element w-full border capitalize rounded-full font-bold p-3 ${list?.active && "bg-white text-black"}`}
                            >
                                {list?.text}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="relative padding-container w-full my-5 py-5 text-center z-1">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {cards?.map((card, index) => (
                            <div
                                key={index}
                                className={`fade-element relative w-full h-[350px] border border-[5px] rounded-[30px] capitalize overflow-hidden flex flex-col justify-end`}
                                style={{
                                    backgroundImage: `url("${card?.image}")`, backgroundSize: "cover", backgroundPosition: "center"
                                }}
                            >
                                <div className="absolute w-full h-full rounded-[30px]" style={{ background: "linear-gradient(180deg, #FFFFFF 0%, #000000 100%)", mixBlendMode: "multiply" }}></div>
                                <div className="absolute w-full h-full rounded-[30px] flex flex-col p-4 justify-end" style={{ zIndex: 1 }}>
                                    <div className="font-bold capitalize">{card?.title}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* 4 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-4 text-base">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold">
                        Leveraging Social Media Platforms
                    </div>
                    <div className="fade-element">
                        With billions of active users globally, social media remains one of the most powerful channels for advertising and promotion. We focus on leveraging the biggest social media platforms such as Instagram, Facebook, and LinkedIn to amplify your message.
                    </div>
                    <div className="fade-element">
                        By combining eye-catching visuals with strategic planning, we ensure every piece of content serves its purpose effectively
                    </div>
                    <div className="fade-element">
                        For example, if you’re looking to boost brand awareness, we might recommend frequent yet valuable posts paired with targeted ads. If lead generation is your goal, we’ll craft compelling calls-to-action within our designs to encourage conversions
                    </div>
                </div>
                {/* 5 */}
                <div className="relative padding-container w-full my-5 py-5 z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold text-end">
                        What Sets Us Apart?
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            At DO DEAL, our approach goes beyond simply producing content; we build strategies rooted in data-driven decisions.
                            From developing detailed content calendars to implementing cutting-edge AI marketing tools, each step is meticulously planned to achieve measurable outcomes. Additionally, staying updated with current trends ensures your brand stays fresh and relevant.
                            <br />
                            We understand no two businesses are alike, which is why all our services are fully customizable.
                            Whether you need assistance managing your entire social media presence or want help fine-tuning specific campaigns, we’ve got you covered.
                        </div>
                    </div>
                </div>
                {/* 6 */}
                <div className="relative padding-container w-full my-5 py-5 z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold text-start">
                        Ready to take your business to the next level?
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            Contact us to learn how DO DEAL CRM can transform the way you manage relationships, streamline processes, and drive growth!
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreativeServices;